import axios from "../lib/axios";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";
import { LaunchError } from "../utils/errors";
import { renewToken } from "./auth";
import {
  ADS_CAMPAIGN_NOT_FOUND,
  MISSING_PARAMETERS,
} from "../i18n/keysTranslations";

const CONTENT_NOT_FOUND = "CONTENT_NOT_FOUND";

const normalizeApprovalReviewResponse = (result) => {
  const data =
    result?.data && typeof result.data === "object" ? result.data : {};

  return {
    ok: Boolean(result?.ok),
    ...data,
    ...(result?.url ? { url: result.url } : {}),
    ...(result?.reviewerID ? { reviewerID: result.reviewerID } : {}),
    ...(result?.message ? { message: result.message } : {}),
    ...(result?.code ? { code: result.code } : {}),
  };
};

const getApprovalReviewHandledError = (error) => {
  const responseData = error?.response?.data;
  const code = responseData?.code || error?.code;

  if (
    [
      ADS_CAMPAIGN_NOT_FOUND,
      CONTENT_NOT_FOUND,
      "invalidEmail",
      MISSING_PARAMETERS,
      "approvalNotEnabled",
      "approvalNotFound",
      "invalidApprovalType",
      "reviewerNotFound",
      "maxReviewersReached",
      "reviewerEmailDuplicated",
      "Unauthorized",
    ].includes(code)
  ) {
    return {
      ok: false,
      code,
      message: responseData?.message || error?.message || "",
    };
  }

  return null;
};

export const startSendApprovalReviewLinkEmail =
  ({ approvalType, approvalID, email, reviewerID = "" }) =>
  async (dispatch) => {
    try {
      const token = await dispatch(renewToken());

      if (!token) {
        return {
          ok: false,
          code: "missingAuthToken",
          message: "Missing auth token",
        };
      }

      const normalizedReviewerID = String(reviewerID || "").trim();

      const { data: result } = await axios({
        method: "post",
        url: `${getCloudFunctionUrl("sendApprovalReviewLinkEmail")}/sendApprovalReviewLinkEmail`,
        data: {
          approvalType,
          approvalID,
          email,
          ...(normalizedReviewerID ? { reviewerID: normalizedReviewerID } : {}),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return normalizeApprovalReviewResponse(result);
    } catch (error) {
      const handledError = getApprovalReviewHandledError(error);
      if (handledError) {
        return handledError;
      }

      const errorFormatted = dispatch(
        LaunchError(error, true, [], {
          functionName: "startSendApprovalReviewLinkEmail",
        })
      );

      return {
        ok: false,
        code: errorFormatted?.code,
        message: errorFormatted?.message || error?.message || "",
      };
    }
  };

export const startAddApprovalReviewer =
  ({ approvalType, approvalID, email }) =>
  async (dispatch) => {
    try {
      const token = await dispatch(renewToken());

      if (!token) {
        return {
          ok: false,
          code: "missingAuthToken",
          message: "Missing auth token",
        };
      }

      const { data: result } = await axios({
        method: "post",
        url: `${getCloudFunctionUrl("addApprovalReviewer")}/addApprovalReviewer`,
        data: {
          approvalType,
          approvalID,
          email,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return normalizeApprovalReviewResponse(result);
    } catch (error) {
      const handledError = getApprovalReviewHandledError(error);
      if (handledError) {
        return handledError;
      }

      const errorFormatted = dispatch(
        LaunchError(error, true, [], {
          functionName: "startAddApprovalReviewer",
        })
      );

      return {
        ok: false,
        code: errorFormatted?.code,
        message: errorFormatted?.message || error?.message || "",
      };
    }
  };
